export default __webpack_public_path__ + "static/media/AceiteSachainchi.44b82c20.jpeg";